// extracted by mini-css-extract-plugin
export default {"errorText":"#721c24","titles":"titles---UZ8ig","titleList":"titleList---H7yXr","titleError":"titleError---hARMS"};